export const DATAWELL = 'DATAWELL';
export const PIVOT = 'PIVOT';
export const CROSS_TAB = 'CROSS_TAB';
export const SLICED = 'SLICED';
export const TABLE = 'TABLE';
export const XY = 'XY';
export const WATERFALL = 'WATERFALL';
export const FUNNEL = 'FUNNEL';
export const SANKEY = 'SANKEY';
export const GAUGE = 'GAUGE';